// Clinical roles, shared between the registration form (select options) and the
// app shell (display label for the signed-in user's role claim).

export const ROLE_OPTIONS = [
  { value: "consultant", label: "Consultant" },
  { value: "registrar", label: "Registrar" },
  { value: "sho", label: "SHO" },
  { value: "fy1", label: "FY1" },
] as const;

export type UserRoleValue = (typeof ROLE_OPTIONS)[number]["value"];

// Single source of truth: both the label lookup and the type guard derive from
// ROLE_OPTIONS, so adding a role means editing one list.
const ROLE_VALUES = new Set<string>(ROLE_OPTIONS.map((o) => o.value));
const ROLE_LABELS: Record<string, string> = Object.fromEntries(
  ROLE_OPTIONS.map((o) => [o.value, o.label]),
);

// Narrows an unvalidated string (e.g. a Firebase custom claim) to a known role.
export function isUserRole(value: unknown): value is UserRoleValue {
  return typeof value === "string" && ROLE_VALUES.has(value);
}

// Tolerant of unknown values (e.g. a future role not yet in this list) — falls
// back to the raw claim rather than throwing in the UI.
export function roleLabel(role: string): string {
  return ROLE_LABELS[role] ?? role;
}
